import {Component, Input} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {MessageResponse} from "../../../core/banner/message-response";
import {BannerService} from "../../../core/banner/banner.service";

@Component(
    {
        selector: 'app-ngbd-modal-content',
        template: `
            <div class="modal-header">
                <h4 class="modal-title">Mensajes de Banner</h4>
                <button type="button" class="close" aria-label="Close" [disabled]="loading" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                ¿ Está seguro que quiere
                <span *ngIf="action === 'activate'" class="font-weight-bold">{{message.active ? 'DESACTIVAR' : 'ACTIVAR'}}</span> el mensaje:
                <span *ngIf="action === 'delete'" class="font-weight-bold">ELIMINAR</span> el mensaje:
                <span class="font-weight-bold">{{message.name}}</span> ?
            </div>
            <div class="modal-footer">
                <div>
                    <button type="button" class="btn btn-danger" [disabled]="loading" (click)="activeModal.close('Close click')">Cancelar
                    </button>
                    <button *ngIf="action === 'activate'" type="button" class="btn btn-primary ml-2" [ladda]="loading" (click)="changeStatusMessage()">Aceptar</button>
                    <button *ngIf="action === 'delete'" type="button" class="btn btn-primary ml-2" [ladda]="loading" (click)="deleteMessage()">Aceptar</button>
                </div>
            </div>
        `
    }
)

export class ActivationMessageModalComponent {
    @Input() message: MessageResponse;
    @Input() action;
    loading = false;

    constructor(public activeModal: NgbActiveModal, public bannerService: BannerService) {
    }

    changeStatusMessage() {
        this.loading = true;
        this.bannerService.activeMessage(this.message.messageKey).subscribe(
            () => {
                this.message.active = !this.message.active;
                this.activeModal.close();
                this.loading = false;
            },
            () => {
                this.loading = false;
            }
        );
    }

  deleteMessage() {
    this.loading = true;
    this.bannerService.deleteMessageOfBanner(this.message.messageKey).subscribe(
      () => {
        this.activeModal.close();
        this.loading = false;
      },
      error => {
        this.loading = false;
        console.log(error);
      }
    );
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/banners/modal/activation-message-modal-component.ts